/* ORIBA REVIVAL FESTIVAL — SECRET ORIBA チャレンジ (sections/rf-secret-challenge.liquid)
 * Touches only <section data-rf-sc>. No secrets live here.
 * Reads only the shopper's own numbers through the Shopify App Proxy (same origin):
 *   GET {me_url}?event={event_id}  →  { secret: { display, required, state: progress|pending|unlocked, granted? } }
 * Writes only numbers (textContent) and data-state; never personal data.
 */
(function () {
  'use strict';
  var STATES = ['guest', 'loading', 'progress', 'pending', 'unlocked', 'granted', 'unavailable'];
  var TIMEOUT_MS = 8000;

  var isInt = function (n) { return typeof n === 'number' && isFinite(n) && Math.floor(n) === n; };

  /* Pure: decide what to show. Anything unexpected → "unavailable" (never claims an unlock it can't prove). */
  var decide = function (o) {
    o = o || {};
    var required = isInt(o.required) && o.required > 0 ? o.required : 10;
    if (!o.loggedIn) return { state: 'guest' };
    if (!o.showProgress) return { state: 'unavailable' };
    if (o.error || !o.me || typeof o.me !== 'object') return { state: 'unavailable' };
    var s = o.me.secret;
    if (!s || typeof s !== 'object') return { state: 'unavailable' };
    // an award already arranged stays shown even if current points later change (returns etc.)
    if (s.granted === true) { var gr = isInt(s.required) && s.required > 0 ? s.required : required; /* SECRET_MULTI_GRANTED_FIX: 1 per 10 points. Keep count / next / to_next even when granted. */if (isInt(s.count) && s.count >= 1 && isInt(s.next) && s.next >= 0 && s.next < gr && isInt(s.to_next) && s.to_next === gr - s.next) {  var gv = mix('granted', { now: s.next, required: gr, left: s.to_next }); gv.count = s.count; gv.unpaid = (isInt(s.count_total) && s.count_total >= s.count ? s.count_total : s.count) - s.count; return gv;} return mix('granted', { now: gr, required: gr, left: 0 }); }
    var display = typeof s.display === 'string' && /^\d+$/.test(s.display) ? Number(s.display) : s.display;
    if (!isInt(display) || display < 0) return { state: 'unavailable' };
    var req = s.required == null ? required : s.required;
    if (!isInt(req) || req <= 0) return { state: 'unavailable' };
    var now = Math.min(display, req);
    var full = { now: req, required: req, left: 0 };
    if (s.state === 'unlocked') {
      // 10ポイントにつき1個（API に count / next / to_next があるとき）: 獲得個数と次の1個までのゲージ
      if (isInt(s.count) && s.count >= 1 && isInt(s.next) && s.next >= 0 && s.next < req && isInt(s.to_next) && s.to_next === req - s.next) {
        var total = isInt(s.count_total) && s.count_total >= s.count ? s.count_total : s.count;
        var v = mix('unlocked', { now: s.next, required: req, left: s.to_next });
        v.count = s.count; v.unpaid = total - s.count;
        return v;
      }
      return mix('unlocked', full);
    }
    if (s.state === 'pending') return display >= req ? mix('pending', full) : { state: 'unavailable' };
    if (s.state === 'progress' || s.state == null) {
      if (display >= req) return { state: 'unavailable' }; // inconsistent answer: show nothing rather than guess
      return mix('progress', { now: now, required: req, left: req - now });
    }
    return { state: 'unavailable' };
  };
  var mix = function (state, v) { return { state: state, now: v.now, required: v.required, left: v.left }; };

  /* Editor preview (theme editor only). */
  var previewView = function (state, points, required) {
    if (STATES.indexOf(state) < 0 || state === 'loading') return null;
    var req = isInt(required) && required > 0 ? required : 10;
    if (state === 'progress') {
      var p = Math.max(0, Math.min(isInt(points) ? points : 0, req - 1));
      return mix('progress', { now: p, required: req, left: req - p });
    }
    if (state === 'unlocked') { var u = mix('unlocked', { now: 3, required: req, left: req - 3 }); u.count = 2; u.unpaid = 0; return u; } // エディタ確認用: 2個獲得・次まであと7
    if (state === 'pending' || state === 'granted') return mix(state, { now: req, required: req, left: 0 });
    return { state: state };
  };

  var paint = function (sec, v) {
    sec.setAttribute('data-state', v.state);
    var multi = isInt(v.count) && v.count >= 1;
    sec.setAttribute('data-multi', multi ? 'true' : 'false');
    sec.setAttribute('data-unpaid', multi && isInt(v.unpaid) && v.unpaid > 0 ? 'true' : 'false');
    var label = sec.querySelector('.rf-sc__now-label');
    if (label) label.textContent = (multi ? sec.getAttribute('data-next-label') : sec.getAttribute('data-now-label')) || label.textContent;
    if (!isInt(v.required)) return;
    var set = function (sel, val) {
      var list = sec.querySelectorAll(sel);
      for (var i = 0; i < list.length; i++) list[i].textContent = String(val);
    };
    set('[data-sc-now]', v.now);
    set('[data-sc-required]', v.required);
    set('[data-sc-left]', v.left);
    if (multi) { set('[data-sc-count]', v.count); set('[data-sc-unpaid-n]', v.unpaid || 0); }
    var bar = sec.querySelector('[data-sc-bar]');
    if (bar) { bar.setAttribute('aria-valuemax', String(v.required)); bar.setAttribute('aria-valuenow', String(v.now)); }
    var fill = sec.querySelector('[data-sc-fill]');
    if (fill) fill.style.width = Math.max(0, Math.min(100, v.now / v.required * 100)) + '%';
  };

  var withEvent = function (u, ev) { return ev ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'event=' + encodeURIComponent(ev) : u; };
  var cache = {};
  var fetchMe = function (url) {
    if (cache[url]) return cache[url];
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () { if (ctl) ctl.abort(); reject(new Error('timeout')); }, TIMEOUT_MS);
    });
    var req = fetch(url, {
      method: 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', 'X-RF-Requested': '1' },
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
    cache[url] = Promise.race([req, timeout]).then(
      function (v) { clearTimeout(timer); return v; },
      function (e) { clearTimeout(timer); delete cache[url]; throw e; });
    return cache[url];
  };

  var init = function (sec) {
    if (!sec || sec.__rfScDone) return;
    sec.__rfScDone = true;
    var required = Number(sec.getAttribute('data-required'));
    if (!isInt(required) || required <= 0) required = 10;

    if (sec.getAttribute('data-design-mode') === 'true') {
      var pv = previewView(sec.getAttribute('data-preview-state'), Number(sec.getAttribute('data-preview-points')), required);
      if (pv) { paint(sec, pv); return; }
    }
    var base = { loggedIn: sec.getAttribute('data-logged-in') === 'true', showProgress: sec.getAttribute('data-show-progress') === 'true', required: required };
    var url = sec.getAttribute('data-me-url') || '';
    var first = decide(base);
    if (first.state === 'guest' || !base.showProgress) { paint(sec, first); return; }
    // only a same-origin path is ever fetched (the App Proxy); anything else is ignored
    if (!/^\/(?!\/)/.test(url)) { paint(sec, { state: 'unavailable' }); return; }
    paint(sec, { state: 'loading' });
    fetchMe(withEvent(url, sec.getAttribute('data-event') || '')).then(function (me) {
      paint(sec, decide({ loggedIn: true, showProgress: true, required: required, me: me }));
    }, function () {
      paint(sec, decide({ loggedIn: true, showProgress: true, required: required, error: true }));
    });
  };

  var boot = function (scope) {
    var list = (scope || document).querySelectorAll('[data-rf-sc]');
    for (var i = 0; i < list.length; i++) {
      try { init(list[i]); } catch (e) { if (window.console) console.warn('[rf-sc]', e); }
    }
  };

  window.RFSecretChallenge = { decide: decide, previewView: previewView };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
